/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Pauschalbesteuerunggeringfuegigsonstige2Inputs */



/**

* @param {_Field_Pauschalbesteuerunggeringfuegigsonstige2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_pauschalbesteuerunggeringfuegigsonstige2 = /** @type {((inputs?: _Field_Pauschalbesteuerunggeringfuegigsonstige2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Pauschalbesteuerunggeringfuegigsonstige2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Pauschalbesteuerung geringfügig (Sonstige)")
});
export { _field_pauschalbesteuerunggeringfuegigsonstige2 as "_field_pauschalbesteuerungGeringfuegigSonstige" }